import React, { useRef, useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  FormControlLabel,
  Checkbox,
  Snackbar,
  Alert,
} from '@mui/material';
import config from '../config/Config';
import moment from 'moment';
import { apiHeaderToken, getAppliedJobDetails } from '../helper/My_Helper';
import axios from 'axios';

const formatDate = (date) => {
  if (!date) return '-';
  return moment(date).format('DD/MM/YYYY');
};

// Helper to get address from permanent_address object
const getAddress = (addressObj) => {
  if (typeof addressObj === 'string') return addressObj;
  if (addressObj?.address) return addressObj.address;
  return '';
};

const SB_FormatView = ({ candidateData, refereeData, formData }) => {
  const formRef = useRef();
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  // State for checkbox and save status
  const appliedJob = getAppliedJobDetails(candidateData);
const [isChecked, setIsChecked] = useState(
  appliedJob?.sb_format_agree === true
);
  // Get sb_format_data from applied job
  const sbFormatData = appliedJob?.sb_format_data || {};
  console.log("SB_FormatView - sbFormatData:", appliedJob);
  // Get referee details from sb_format_data
  const refereeDetails = sbFormatData?.referee_details || {};
  
  // Get certificate details from sb_format_data
  const certificateDetails = sbFormatData?.certificate_details || {};

  // Get data from formData or fallback to other sources
  const getValue = (key) => {
    return formData?.[key] || '';
  };

  // Candidate details
  const candidateName = getValue('candidateName') || candidateData?.name || '';
  const candidateFatherName = getValue('candidateFatherName') || candidateData?.applicant_form_data?.father_hushband_name || '';
  const candidateResidence = getValue('candidateResidence') || getAddress(candidateData?.applicant_form_data?.permanent_address) || '';
  const candidatePosition = getValue('candidatePosition') || appliedJob?.job_designation || candidateData?.designation || '';

  // Referee details - FIXED to use correct data source
  const refereeName = getValue('refereeName') || refereeDetails?.name || refereeData?.name || '';
  const refereeFatherName = getValue('refereeFatherName') || refereeDetails?.father_name || refereeData?.father_name || '';
  const refereeResidence = getValue('refereeResidence') || refereeDetails?.residence || refereeData?.residence || '';
  const refereeEmployment = getValue('refereeEmployment') || refereeDetails?.employment || refereeData?.employment || '';
  const refereeDesignation = getValue('refereeDesignation') || refereeDetails?.designation || refereeData?.designation || '';
  const refereeKnownSince = getValue('knownSince') || refereeDetails?.known_since || refereeData?.known_since || '';

  // Certificate details - only keep what's used
  const certifierName = getValue('certifierName') || certificateDetails?.certifier_name || '';
  const certifierDesignation = getValue('certifierDesignation') || certificateDetails?.certifier_designation || '';
  const certifierContact = getValue('certifierContact') || certificateDetails?.certifier_contact || '';
  const certifierKnownSince = getValue('certifierKnownSince') || certificateDetails?.certifier_known_since || '';
  const certifierCapacity = getValue('certifierCapacity') || certificateDetails?.certifier_capacity || '';
  const recommendationText = getValue('recommendationText') || certificateDetails?.recommendation || '';

  // Quality ratings from certificate details
  const qualities = certificateDetails?.qualities || {};

  // Get approval note id and candidate id
  const approvalNoteId = appliedJob?.approval_note_data?.note_id || '';
  const candidateId = candidateData?.id || candidateData?._id || '';

  // Handle checkbox change
  const handleCheckboxChange = async (event) => {
    const checked = event.target.checked;
    setIsChecked(checked);

    if (checked) {
      // Call API when checkbox is checked
      await saveReferenceForm();
    }
  };

  // Save reference form API call
  const saveReferenceForm = async () => {
    if (!approvalNoteId || !candidateId) {
      setSnackbar({
        open: true,
        message: 'Missing approval note ID or candidate ID',
        severity: 'error',
      });
      setIsChecked(false);
      return;
    }

    setSaving(true);
    try {
      let response = await axios.post(`${config.API_URL}saverefrenceform`,{ appliedJobId: appliedJob?._id,candidateid: candidateId,sb_format_agree:true,},apiHeaderToken(config.API_TOKEN))
     
      if (response.status) {
        setSnackbar({
          open: true,
          message: 'Reference form saved successfully!',
          severity: 'success',
        });
      } else {
        setSnackbar({
          open: true,
          message: response?.message || 'Failed to save reference form',
          severity: 'error',
        });
        setIsChecked(false);
      }
    } catch (error) {
      console.error('Error saving reference form:', error);
      setSnackbar({
        open: true,
        message: 'An error occurred while saving. Please try again.',
        severity: 'error',
      });
      setIsChecked(false);
    } finally {
      setSaving(false);
    }
  };

  // Handle snackbar close
  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // Quality rating display component
  const QualityDisplay = ({ label, rating, anyOtherText = '' }) => (
    <TableRow>
      <TableCell sx={{ border: '1px solid #000', p: 0.8, fontWeight: 'bold', fontSize: '10px', width: '30%' }}>
        {label} {anyOtherText && <span style={{ fontWeight: 'normal' }}>({anyOtherText})</span>}
      </TableCell>
      <TableCell sx={{ border: '1px solid #000', p: 0.8, textAlign: 'center', fontSize: '10px', width: '17.5%' }}>
        {rating === 'excellent' && '✓'}
      </TableCell>
      <TableCell sx={{ border: '1px solid #000', p: 0.8, textAlign: 'center', fontSize: '10px', width: '17.5%' }}>
        {rating === 'veryGood' && '✓'}
      </TableCell>
      <TableCell sx={{ border: '1px solid #000', p: 0.8, textAlign: 'center', fontSize: '10px', width: '17.5%' }}>
        {rating === 'average' && '✓'}
      </TableCell>
      <TableCell sx={{ border: '1px solid #000', p: 0.8, textAlign: 'center', fontSize: '10px', width: '17.5%' }}>
        {rating === 'belowAverage' && '✓'}
      </TableCell>
    </TableRow>
  );

  return (
    <Box>
      <Box ref={formRef} sx={{ maxWidth: '100%', mx: 'auto', fontFamily: 'Times New Roman, serif' }}>

        {/* ===== SAVE REFERENCE FORM CHECKBOX (Centered, above heading) ===== */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mb: 2,
            p: 1.5,
            border: '1px solid #1976d2',
            borderRadius: 1,
            backgroundColor: '#f5f9ff',
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={isChecked}
                onChange={handleCheckboxChange}
                disabled={saving}
                color="primary"
              />
            }
            label={
              <Typography
                variant="h4"
                sx={{
                  fontFamily: 'Times New Roman, serif',
                  fontSize: '22px',
                  fontWeight: 'bold',
                  color: '#1976d2',
                  letterSpacing: '0.5px',
                }}
              >
                {saving ? 'Saving Reference Form...' : 'Save Reference Form'}
              </Typography>
            }
          />
        </Box>

        {/* ===== PAGE 1: REFERENCE TESTIMONIAL ===== */}
        <Paper
          variant="outlined"
          sx={{
            p: 2,
            border: 'none',
            backgroundColor: '#fff'
          }}
        >
          {/* Header with Logo */}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '2px solid #000',
            pb: 1.5,
            mb: 2
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <img
                src='/logo512.png'
                alt='HLFPPT Logo'
                height="50"
              />
            </Box>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 'bold',
                fontFamily: 'Times New Roman, serif',
                fontSize: '20px',
                letterSpacing: '1px'
              }}
            >
              REFERENCE TESTIMONIAL
            </Typography>
            <Box sx={{ width: '50px' }} />
          </Box>

          {/* Page 1 Content */}
          <Box sx={{ fontFamily: 'Times New Roman, serif' }}>
            <Typography variant="body2" sx={{ lineHeight: 1.8, fontSize: '12px', mb: 0.5 }}>
              <b>Whereas</b>, Hindustan Latex Family Planning Promotion Trust (hereinafter referred to as "the Trust") and <b>Mr./Ms.</b> <b>{candidateName}</b> <b>S/o / D/o</b> <b>{candidateFatherName}</b>, a resident of <b>{candidateResidence}</b>, whose specimen signatures are appended below, has been selected for a contractual appointment as a <b>{candidatePosition}</b> to carry out such duties as are specified in his appointment letter, or as may be entrusted from time to time upon him/her and in the course of his/her carrying out his/her duties he/she would have to be entrusted with various brochures/materials/products/assets of the Organization as may be required to perform his/her job; and one of the preconditions for the appointment of in the Organization/Project is furnishing of this reference testimonial; and
            </Typography>

            <Typography variant="body2" sx={{ lineHeight: 1.8, fontSize: '12px', mb: 0.5 }}>
              <b>Whereas</b>, Mr./Ms. <b>{candidateName}</b> has approached me to stand as his/her references and 
              <b>Whereas</b>, the undersigned, <b>Shri</b> <b>{refereeName}</b> <b>s/o</b> <b>{refereeFatherName}</b>, a resident of <b>{refereeResidence}</b> in the employment of the <b>{refereeEmployment}</b> as <b>{refereeDesignation}</b> and is willing to stand references for <b>{candidateName}</b>.
            </Typography>

            <Typography variant="body2" sx={{ lineHeight: 1.8, fontSize: '12px', mb: 1, mt: 1 }}>
              I, hereby agree to give my reference for the above candidate, that the candidate is known to me in person since from <b>{refereeKnownSince}</b> and bears a good moral character. He/She has not being convicted by any court of law or litigant incisive to the best of my knowledge and belief. In case of any impersonification, misappropriation, fraud or financial irregularities, breach of confidentiality etc. reported against the candidate during the course of his/her employment with the organization; the management may invoke this reference and take appropriate action against the candidate. I also understand that in case of any such abovementioned act indulged by the candidate even after leaving the employment of your Organization; your management reserves all right to approach his/her prospective/next employer seeking appropriate action against him/her without prejudice to your organization's rights and contentions.
            </Typography>

            {/* Signatures Section - Page 1 */}
            <Box sx={{ mt: 2, pt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', fontSize: '11px', mb: 0.5 }}>
                    Specimen Signature of (Candidate)
                  </Typography>
                  <Box sx={{
                    borderBottom: '2px solid #000',
                    minHeight: '60px',
                    display: 'flex',
                    alignItems: 'flex-end',
                    p: 1,
                    backgroundColor: '#fafafa',
                    mb: 0.5
                  }}>
                    {candidateData?.applicant_form_data?.signature ? (
                      <img
                        src={`${config.IMAGE_PATH}${candidateData.applicant_form_data.signature}`}
                        alt="Candidate Signature"
                        style={{ maxHeight: '45px', width: 'auto' }}
                      />
                    ) : (
                      <Typography variant="body2" color="textSecondary" sx={{ fontFamily: 'Arial, sans-serif', fontSize: '11px' }}>
                        No signature available
                      </Typography>
                    )}
                  </Box>
                  <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: '11px' }}>
                    Shri {candidateName}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', fontSize: '11px', mb: 0.5 }}>
                    Signature of Referee
                  </Typography>
                  <Box sx={{
                    borderBottom: '2px solid #000',
                    minHeight: '60px',
                    display: 'flex',
                    alignItems: 'flex-end',
                    p: 1,
                    backgroundColor: '#fafafa',
                    mb: 0.5
                  }}>
                    {refereeDetails?.signature ? (
                      <img
                        src={`${config.IMAGE_PATH}${refereeDetails.signature}`}
                        alt="Referee Signature"
                        style={{ maxHeight: '45px', width: 'auto' }}
                      />
                    ) : (
                      <Typography variant="body2" color="textSecondary" sx={{ fontFamily: 'Arial, sans-serif', fontSize: '11px' }}>
                        No signature available
                      </Typography>
                    )}
                  </Box>
                  <Typography variant="body2" sx={{ fontWeight: 'bold', fontSize: '11px' }}>
                    {refereeName}
                  </Typography>
                </Grid>
              </Grid>

              <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="body2" sx={{ fontSize: '12px' }}>
                  <b>Date:</b> {formatDate(sbFormatData?.date || appliedJob?.onboard_date) || '________'}
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '12px' }}>
                  <b>Place:</b> {sbFormatData?.place || appliedJob?.proposed_location || appliedJob?.job_location || '________'}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Paper>

        {/* ===== PAGE 2: CERTIFICATE ===== */}
        <Paper
          variant="outlined"
          sx={{
            p: 3,
            mt: 2,
            border: 'none',
            backgroundColor: '#fff',
            pageBreakBefore: 'always'
          }}
        >
          {/* Centered Header */}
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
              <img
                src='/logo512.png'
                alt='HLFPPT Logo'
                height="55"
              />
            </Box>

            <Typography
              variant="h5"
              sx={{
                fontWeight: 'bold',
                fontFamily: 'Times New Roman, serif',
                fontSize: '20px',
                letterSpacing: '1px',
                mb: 0.5
              }}
            >
              Annexure 1
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 'bold',
                fontFamily: 'Times New Roman, serif',
                fontSize: '18px',
                letterSpacing: '0.5px',
                mb: 1.5
              }}
            >
              For Confidential use only
            </Typography>

            <Typography
              variant="caption"
              display="block"
              sx={{
                mb: 2,
                color: '#000',
                fontFamily: 'Times New Roman, serif',
                fontSize: '10.5px',
                fontStyle: 'italic',
                maxWidth: '85%',
                mx: 'auto',
                lineHeight: 1.4
              }}
            >
              (To be filled in by a Gazetted Officer in State/ Central Government Service/ Officers in PSUS/ Officers in Nationalized Banks/ Principals in Government aided schools)
            </Typography>

            <Typography
              variant="h5"
              sx={{
                fontWeight: 'bold',
                fontFamily: 'Times New Roman, serif',
                fontSize: '22px',
                letterSpacing: '1.5px',
                textDecoration: 'underline',
                mt: 1
              }}
            >
              CERTIFICATE
            </Typography>
          </Box>

          {/* Page 2 Content */}
          <Box sx={{ fontFamily: 'Times New Roman, serif' }}>
            <Typography variant="body2" sx={{ lineHeight: 1.8, fontSize: '12px', mb: 1.5 }}>
              I have known <b>{candidateName}</b> resident of <b>{candidateResidence}</b> since <b>{certifierKnownSince}</b> years in my capacity as <b>{certifierCapacity}</b> to the candidate. As regards the candidate, I rank him as indicated here with reference to the professional and personal qualities.
            </Typography>

            {/* Quality Table */}
            <TableContainer
              component={Paper}
              variant="outlined"
              sx={{
                mt: 2,
                mb: 2,
                border: '1px solid #000',
                borderRadius: 0
              }}
            >
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell sx={{
                      border: '1px solid #000',
                      fontWeight: 'bold',
                      backgroundColor: '#fff',
                      p: 1,
                      fontSize: '10px',
                      fontFamily: 'Times New Roman, serif',
                      width: '30%'
                    }}>
                      Quality/Attribute
                    </TableCell>
                    <TableCell sx={{
                      border: '1px solid #000',
                      textAlign: 'center',
                      fontWeight: 'bold',
                      backgroundColor: '#fff',
                      p: 1,
                      fontSize: '10px',
                      fontFamily: 'Times New Roman, serif',
                      width: '17.5%'
                    }}>
                      Excellent
                    </TableCell>
                    <TableCell sx={{
                      border: '1px solid #000',
                      textAlign: 'center',
                      fontWeight: 'bold',
                      backgroundColor: '#fff',
                      p: 1,
                      fontSize: '10px',
                      fontFamily: 'Times New Roman, serif',
                      width: '17.5%'
                    }}>
                      Very Good
                    </TableCell>
                    <TableCell sx={{
                      border: '1px solid #000',
                      textAlign: 'center',
                      fontWeight: 'bold',
                      backgroundColor: '#fff',
                      p: 1,
                      fontSize: '10px',
                      fontFamily: 'Times New Roman, serif',
                      width: '17.5%'
                    }}>
                      Average
                    </TableCell>
                    <TableCell sx={{
                      border: '1px solid #000',
                      textAlign: 'center',
                      fontWeight: 'bold',
                      backgroundColor: '#fff',
                      p: 1,
                      fontSize: '10px',
                      fontFamily: 'Times New Roman, serif',
                      width: '17.5%'
                    }}>
                      Below Average
                    </TableCell>
                  </TableRow>
                  <QualityDisplay
                    label="Ability to perform dedicated service"
                    rating={qualities?.abilityToPerform || ''}
                  />
                  <QualityDisplay
                    label="Professional Outlook"
                    rating={qualities?.professionalOutlook || ''}
                  />
                  <QualityDisplay
                    label="Sincerity"
                    rating={qualities?.sincerity || ''}
                  />
                  <QualityDisplay
                    label="Honesty"
                    rating={qualities?.honesty || ''}
                  />
                  <QualityDisplay
                    label="Ability for Team – work"
                    rating={qualities?.teamWork || ''}
                  />
                  <QualityDisplay
                    label="Discipline/Conduct"
                    rating={qualities?.discipline || ''}
                  />
                  <QualityDisplay
                    label="Any Other"
                    rating={qualities?.anyOtherRating || ''}
                    anyOtherText={qualities?.anyOther || ''}
                  />
                </TableBody>
              </Table>
            </TableContainer>

            {/* Recommendation Section */}
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" sx={{ lineHeight: 1.8, fontSize: '12px' }}>
                In my opinion Mr./Ms. <b>{candidateName}</b> is the most suitable choice for <b>{candidatePosition}</b> in your organization because
              </Typography>
              <Paper
                variant="outlined"
                sx={{
                  p: 1.5,
                  mt: 0.5,
                  mb: 2,
                  border: '1px solid #000',
                  borderRadius: 0,
                  backgroundColor: '#fff',
                  minHeight: '60px'
                }}
              >
                <Typography variant="body2" sx={{ lineHeight: 1.8, fontSize: '11px', fontFamily: 'Times New Roman, serif' }}>
                  {recommendationText || '_________________________________________________'}
                </Typography>
              </Paper>
            </Box>

            {/* Certifier Details */}
            <Box sx={{
              mt: 2,
              p: 2,
              border: '1px solid #000',
              borderRadius: 0,
              backgroundColor: '#fff'
            }}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ lineHeight: 2, fontSize: '12px' }}>
                    <b>Signature:</b>
                    <Box sx={{
                      display: 'inline-block',
                      borderBottom: '2px solid #000',
                      minWidth: '180px',
                      minHeight: '40px',
                      ml: 1,
                      verticalAlign: 'bottom',
                      padding: '3px'
                    }}>
                      {certificateDetails?.certifier_signature ? (
                        <img
                          src={`${config.IMAGE_PATH}${certificateDetails.certifier_signature}`}
                          alt="Certifier Signature"
                          style={{ maxHeight: '35px', width: 'auto' }}
                        />
                      ) : (
                        <span style={{ color: '#999', fontSize: '11px' }}>__________</span>
                      )}
                    </Box>
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ lineHeight: 2, fontSize: '12px' }}>
                    <b>Name of the reference:</b> {certifierName || '___________________'}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ lineHeight: 2, fontSize: '12px' }}>
                    <b>Contact Telephone Number:</b> {certifierContact || '___________________'}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" sx={{ lineHeight: 2, fontSize: '12px' }}>
                    <b>Designation with Official seal:</b> {certifierDesignation || '___________________'}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body2" sx={{ lineHeight: 2, fontSize: '12px' }}>
                    <b>Date:</b> {formatDate(sbFormatData?.date || appliedJob?.onboard_date) || '________'}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body2" sx={{ lineHeight: 2, fontSize: '12px' }}>
                    <b>Place:</b> {sbFormatData?.place || appliedJob?.proposed_location || appliedJob?.job_location ||'________'}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Paper>
      </Box>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default SB_FormatView;